import cn from "classnames";
import * as uuid from "uuid";

import s from "./Radio.module.scss";

const Radio = ({ className, color, ...props }) => {
  const id = uuid.v4();
  return (
    <div className={cn(s.radio, className, color && s[color])}>
      <input id={id} type="radio" {...props} />
      <label htmlFor={id}>
        <span />
        {props.value}
      </label>
    </div>
  );
};

export default Radio;
